import styled from "styled-components";

export const CMCircularProgress = styled.div((props) => ({
  position: "relative",
  width: "100%",

  "& > div": {
    width: "80%",
    position: "absolute",
    top: "52%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fill: props.theme.palette.blue["800"],

    "& text": {
      dominantBaseline: "middle",
      textAnchor: "middle",
    },
  },

  "& .current-progress": {
    width: "100%",
    position: "absolute",
    left: "2px",
    top: "-2px",
    color: props.theme.palette.blue["800"],
  },

  "& .placeholder-progress": {
    color:
      props.value > 0
        ? props.theme.palette.blue["500"]
        : props.theme.palette.gray["700"],
  },
}));

export const CMLinearProgress = styled.div((props) => ({
  width: "90%",
  margin: "auto",

  "& > p": {
    marginLeft:
      props.value > 9
        ? `calc(${props.value}% - 3rem)`
        : `calc(${props.value}% - 5rem)`,
    fontSize: "22px",
    color: props.theme.palette.green["800"],
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.workSans,
  },

  '& .progressLabel':{
    display:"flex",
    alignItems: 'center',
    marginLeft:
      props.value > 9
        ? `calc(${props.value}% - 3rem)`
        : `calc(${props.value}% - 5rem)`,
    fontSize: "22px",
    color: props.theme.palette.green["800"],
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.workSans,
  },

  "& .linear-progress": {
    height: 10,
    borderRadius: 5,
    backgroundColor: props.theme.palette.gray["700"],

    "& span": {
      borderRadius: 5,
      backgroundColor: props.theme.palette.green["700"],
    },
    [`@media (min-width: 2000px)`]: {
      height: "0.8vh",
    },
  },

  [`@media (min-width: 2000px)`]: {
    "& p":{
     fontSize:"2vh"
    },
    "& img":{
      width:"2vw !important",
      height:"2vh !important"
     }
  },
}));
